// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section___YXr5","padding-x":"Section_padding-x__EZAi4","padding-y":"Section_padding-y__N__pH"};